import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";
import React from 'react';
import { Box } from "../";

var Card = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    boxShadow: "default",
    borderRadius: "default",
    bg: "white",
    p: 4
  }, props));
}, {
  target: "e19a0egr0",
  label: "Card"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUUiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2FyZC9DYXJkLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCb3ggfSBmcm9tICcuLi8nO1xuXG5jb25zdCBDYXJkID0gc3R5bGVkKChwcm9wcykgPT4gKFxuICA8Qm94IGJveFNoYWRvdz1cImRlZmF1bHRcIiBib3JkZXJSYWRpdXM9XCJkZWZhdWx0XCIgYmc9XCJ3aGl0ZVwiIHA9ezR9IHsuLi5wcm9wc30gLz5cbikpYGA7XG5cbkNhcmQucHJvcFR5cGVzID0gQm94LnByb3BUeXBlcztcblxuZXhwb3J0IGRlZmF1bHQgQ2FyZDtcbiJdfQ== */");

Card.propTypes = Box.propTypes;
export default Card;